import { Link } from 'react-router-dom'
import { Mail, ArrowRight, ArrowLeft } from 'lucide-react'
import '../Pages.css'

export default function AddEmailAccount() {
  return (
    <div className="page email-accounts-page animate-fade-in">
      <div className="page-header">
        <div className="header-info">
          <h2>Connect Email Account</h2>
          <p>Choose how you want to connect your email account for sending campaigns</p>
        </div>
        <Link to="/email-accounts" className="btn btn-ghost">
          <ArrowLeft size={18} />
          <span>Back</span>
        </Link>
      </div>

      <div className="card" style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div className="card-header">
          <h3>
            <Mail size={20} />
            Select Connection Method
          </h3>
        </div>

        <div style={{ padding: '2rem' }}>
          <div style={{ display: 'grid', gap: '1.5rem' }}>
            {/* Google Workspace Card */}
            <Link to="/accounts/connect/google" style={{ textDecoration: 'none' }}>
              <div className="card" style={{
                transition: 'all 0.2s',
                cursor: 'pointer',
                borderWidth: '2px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-primary)'
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(99, 102, 241, 0.2)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-border)'
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = 'none'
              }}>
                <div style={{ padding: '1.5rem', display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, #4285F4 0%, #34A853 100%)',
                    borderRadius: 'var(--radius-lg)',
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    color: 'white',
                    flexShrink: 0
                  }}>
                    G
                  </div>

                  <div style={{ flex: 1 }}>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                      Google Workspace
                    </h4>
                    <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem', marginBottom: '0.75rem' }}>
                      Gmail / G-Suite
                    </p>
                    <ul style={{
                      listStyle: 'none',
                      padding: 0,
                      margin: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.375rem'
                    }}>
                      <li style={{
                        fontSize: '0.85rem',
                        color: 'var(--color-text-muted)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <span style={{
                          width: '4px',
                          height: '4px',
                          background: 'var(--color-primary)',
                          borderRadius: '50%'
                        }} />
                        Connect using app password
                      </li>
                      <li style={{
                        fontSize: '0.85rem',
                        color: 'var(--color-text-muted)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <span style={{
                          width: '4px',
                          height: '4px',
                          background: 'var(--color-primary)',
                          borderRadius: '50%'
                        }} />
                        2-step verification required
                      </li>
                      <li style={{
                        fontSize: '0.85rem',
                        color: 'var(--color-text-muted)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <span style={{
                          width: '4px',
                          height: '4px',
                          background: 'var(--color-primary)',
                          borderRadius: '50%'
                        }} />
                        Quick setup process
                      </li>
                    </ul>
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    background: 'var(--color-bg-hover)',
                    borderRadius: '50%',
                    color: 'var(--color-primary)',
                    flexShrink: 0
                  }}>
                    <ArrowRight size={20} />
                  </div>
                </div>
              </div>
            </Link>

            {/* IMAP/SMTP Card */}
            <Link to="/accounts/connect/imap" style={{ textDecoration: 'none' }}>
              <div className="card" style={{
                transition: 'all 0.2s',
                cursor: 'pointer',
                borderWidth: '2px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-primary)'
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(99, 102, 241, 0.2)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-border)'
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = 'none'
              }}>
                <div style={{ padding: '1.5rem', display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                    borderRadius: 'var(--radius-lg)',
                    fontSize: '1.75rem',
                    flexShrink: 0
                  }}>
                    <Mail size={32} color="white" />
                  </div>

                  <div style={{ flex: 1 }}>
                    <h4 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                      Any Provider
                    </h4>
                    <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem', marginBottom: '0.75rem' }}>
                      IMAP / SMTP
                    </p>
                    <ul style={{
                      listStyle: 'none',
                      padding: 0,
                      margin: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.375rem'
                    }}>
                      <li style={{
                        fontSize: '0.85rem',
                        color: 'var(--color-text-muted)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <span style={{
                          width: '4px',
                          height: '4px',
                          background: 'var(--color-primary)',
                          borderRadius: '50%'
                        }} />
                        Connect any email provider
                      </li>
                      <li style={{
                        fontSize: '0.85rem',
                        color: 'var(--color-text-muted)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <span style={{
                          width: '4px',
                          height: '4px',
                          background: 'var(--color-primary)',
                          borderRadius: '50%'
                        }} />
                        Manual IMAP/SMTP configuration
                      </li>
                      <li style={{
                        fontSize: '0.85rem',
                        color: 'var(--color-text-muted)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <span style={{
                          width: '4px',
                          height: '4px',
                          background: 'var(--color-primary)',
                          borderRadius: '50%'
                        }} />
                        Connection testing included
                      </li>
                    </ul>
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    background: 'var(--color-bg-hover)',
                    borderRadius: '50%',
                    color: 'var(--color-primary)',
                    flexShrink: 0
                  }}>
                    <ArrowRight size={20} />
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Help Text */}
          <div style={{
            marginTop: '2rem',
            padding: '1rem 1.25rem',
            background: 'var(--color-bg-primary)',
            borderRadius: 'var(--radius-md)',
            border: '1px solid var(--color-border)'
          }}>
            <p style={{
              fontSize: '0.85rem',
              color: 'var(--color-text-secondary)',
              margin: 0,
              lineHeight: '1.6'
            }}>
              <strong style={{ color: 'var(--color-text-primary)' }}>Need help?</strong> Choose Google Workspace if you're using Gmail or G-Suite.
              For other providers like Outlook, Yahoo, or custom domains, use the IMAP/SMTP option.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
